import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A generation is a single call to an LLM.`}</p>
    <p><strong parentName="p">{`Event name`}</strong>{`: `}<inlineCode parentName="p">{`$ai_generation`}</inlineCode>{`  `}</p>
    <h3 {...{
      "id": "core-properties"
    }}>{`Core properties`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_trace_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The trace ID (a UUID to group AI events) like `}<inlineCode parentName="td">{`conversation_id`}</inlineCode><br />{`Must contain only letters, numbers, and special characters: `}<inlineCode parentName="td">{`-`}</inlineCode>{`, `}<inlineCode parentName="td">{`_`}</inlineCode>{`, `}<inlineCode parentName="td">{`~`}</inlineCode>{`, `}<inlineCode parentName="td">{`.`}</inlineCode>{`, `}<inlineCode parentName="td">{`@`}</inlineCode>{`, `}<inlineCode parentName="td">{`(`}</inlineCode>{`, `}<inlineCode parentName="td">{`)`}</inlineCode>{`, `}<inlineCode parentName="td">{`!`}</inlineCode>{`, `}<inlineCode parentName="td">{`'`}</inlineCode>{`, `}<inlineCode parentName="td">{`:`}</inlineCode>{`, `}<code>{`|`}</code>{` `}<br />{`Example: `}<inlineCode parentName="td">{`d9222e05-8708-41b8-98ea-d4a21849e761`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_span_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Unique identifier for this generation`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_span_name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Name given to this generation `}<br />{`Example: `}<inlineCode parentName="td">{`summarize_text`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_parent_id`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Parent span ID for tree view grouping`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_model`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The model used `}<br />{`Example: `}<inlineCode parentName="td">{`gpt-5-mini`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_provider`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The LLM provider `}<br />{`Example: `}<inlineCode parentName="td">{`openai`}</inlineCode>{`, `}<inlineCode parentName="td">{`anthropic`}</inlineCode>{`, `}<inlineCode parentName="td">{`gemini`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_input`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of messages sent to the LLM. Each message should have a `}<inlineCode parentName="td">{`role`}</inlineCode>{` property with one of: `}<inlineCode parentName="td">{`"user"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"system"`}</inlineCode>{`, or `}<inlineCode parentName="td">{`"assistant"`}</inlineCode>{` `}<br />{`Example: `}<inlineCode parentName="td">{`[{"role": "user", "content": [{"type": "text", "text": "What's in this image?"}, {"type": "image", "image": "https://example.com/image.jpg"}, {"type": "function", "function": {"name": "get_weather", "arguments": {"location": "San Francisco"}}}]}]`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_input_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of tokens in the input (often found in response.usage)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_output_choices`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`List of response choices from the LLM. Each choice should have a `}<inlineCode parentName="td">{`role`}</inlineCode>{` property with one of: `}<inlineCode parentName="td">{`"user"`}</inlineCode>{`, `}<inlineCode parentName="td">{`"system"`}</inlineCode>{`, or `}<inlineCode parentName="td">{`"assistant"`}</inlineCode>{` `}<br />{`Example: `}<inlineCode parentName="td">{`[{"role": "assistant", "content": [{"type": "text", "text": "I can see a hedgehog in the image."}, {"type": "function", "function": {"name": "get_weather", "arguments": {"location": "San Francisco"}}}]}]`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_output_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of tokens in the output (often found in response.usage)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_latency`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The latency of the LLM call in seconds`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_http_status`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The HTTP status code of the response`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_base_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The base URL of the LLM provider `}<br />{`Example: `}<inlineCode parentName="td">{`https://api.openai.com/v1`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_request_url`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The full URL of the request made to the LLM API `}<br />{`Example: `}<inlineCode parentName="td">{`https://api.openai.com/v1/chat/completions`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_is_error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Boolean to indicate if the request was an error`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_error`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The error message or object`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "cost-properties"
    }}>{`Cost properties`}</h3>
    <p>{`Cost properties are optional as we can automatically calculate them from model and token counts. If you want, you can provide your own cost property instead.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_input_cost_usd`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The cost in USD of the input tokens`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_output_cost_usd`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The cost in USD of the output tokens`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_total_cost_usd`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` The total cost in USD (input + output)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "cache-properties"
    }}>{`Cache properties`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_cache_read_input_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Number of tokens read from cache`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_cache_creation_input_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Number of tokens written to cache (Anthropic-specific)`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "model-parameters"
    }}>{`Model parameters`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_temperature`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Temperature parameter used in the LLM request`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_stream`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Whether the response was streamed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_max_tokens`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Maximum tokens setting for the LLM response`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ai_tools`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><em parentName="td">{`(Optional)`}</em>{` Tools/functions available to the LLM `}<br />{`Example: `}<inlineCode parentName="td">{`[{"type": "function", "function": {"name": "get_weather", "parameters": {...}}}]`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "example-api-call"
    }}>{`Example API call`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X POST "<ph_client_api_host>/i/v0/e/" \\
     -H "Content-Type: application/json" \\
     -d '{
         "api_key": "<ph_project_api_key>",
         "event": "$ai_generation",
         "properties": {
             "distinct_id": "user_123",
             "$ai_trace_id": "d9222e05-8708-41b8-98ea-d4a21849e761",
             "$ai_model": "gpt-4o",
             "$ai_provider": "openai",
             "$ai_input": [{"role": "user", "content": [{"type": "text", "text": "Analyze this data and suggest improvements"}]}],
             "$ai_input_tokens": 150,
             "$ai_output_choices": [{"role": "assistant", "content": [{"type": "text", "text": "Based on the data, here are my suggestions..."}]}],
             "$ai_output_tokens": 280,
             "$ai_latency": 2.45,
             "$ai_http_status": 200,
             "$ai_base_url": "https://api.openai.com/v1",
             "$ai_request_url": "https://api.openai.com/v1/chat/completions",
             "$ai_is_error": false,
             "$ai_temperature": 0.7,
             "$ai_stream": false,
             "$ai_max_tokens": 500,
             "$ai_tools": [{"type": "function", "function": {"name": "analyze_data", "description": "Analyzes data and provides insights", "parameters": {"type": "object", "properties": {"data_type": {"type": "string"}}}}}],
             "$ai_cache_read_input_tokens": 50,
             "$ai_span_name": "data_analysis_chat"
         },
         "timestamp": "2025-01-30T12:00:00Z"
     }'

`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      